/* The zero state (no results with year data returned) for DateFilter */

import React from 'react';
import styled from 'astroturf/react';

import $image_url from 'js/utils/image_url';
import LoadingDots from '../LoadingDots';

const Container = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex-direction: column;
  margin-bottom: 52px;
  font-family: Roboto;
  font-style: normal;
  cursor: auto;

  &.isMobile {
    margin-bottom: 0;
    width: 100%;
  }
`;

const InnerContainer = styled.div`
  height: 130px;
  display: flex;
  flex-direction: column;
`;

const ZeroStateText = styled.div`
  font-weight: 400;
  font-size: 12px;
  text-transform: uppercase;
  color: #333333;
  margin: auto;
`;

const HorizontalBar = styled.div`
  width: 100%;
  height: 2px;
  background-color: #c4c4c4;
  opacity: 0.2;
  margin-bottom: 1px;
`;

const ThumbsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Thumb = styled.img`
  opacity: 0.2;
  /* filter color: #c4c4c4 */
  filter: brightness(0) saturate(100%) invert(93%) sepia(0%) saturate(0%)
    hue-rotate(274deg) brightness(85%) contrast(93%);
`;

const ButtonsWrapper = styled.div`
  height: 29px;
  margin-top: 13px;
  opacity: 0.5;
`;

const Button = styled.button<{ left?: boolean; right?: boolean }>`
  background: transparent;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.01em;
  color: #094ec3;
  width: 50%;
  height: 100%;
  border: none;
  cursor: auto;
  border: 1px solid #c4c4c4;
  color: #c4c4c4;

  &.left {
    border-radius: 4px 0 0 4px;
  }

  &.right {
    border-radius: 0 4px 4px 0;
    border-left: none;
  }
`;

type Props = {
  isMobile: boolean;
  loading: boolean;
};

const ZeroState = ({ isMobile, loading }: Props) => (
  <Container isMobile={isMobile}>
    <InnerContainer>
      {loading ? (
        <LoadingDots style={{ margin: 'auto' }} />
      ) : (
        <ZeroStateText>No Results Found</ZeroStateText>
      )}
      <HorizontalBar />
      <ThumbsWrapper>
        <Thumb src={$image_url('search/date-filter-slider.svg')} />
        <Thumb src={$image_url('search/date-filter-slider.svg')} />
      </ThumbsWrapper>
    </InnerContainer>
    <ButtonsWrapper>
      <Button left>Past Year</Button>
      <Button right>Past 5 Years</Button>
    </ButtonsWrapper>
  </Container>
);

export default ZeroState;
